import { useEffect, useRef, useState } from "react";

const useIntersection = (callback: any) => {
  const [observerTarget, setObserverTarget] = useState<HTMLElement | null>(
    null,
  );

  const observer = useRef(
    new IntersectionObserver(
      ([entry]) => {
        if (!entry.isIntersecting) return;

        callback();
      },
      { threshold: 1 },
    ),
  );

  useEffect(() => {
    const currentTarget = observerTarget;
    const currentObserver = observer.current;

    if (currentTarget) {
      currentObserver.observe(currentTarget);
    }

    return () => {
      if (currentTarget) {
        currentObserver.unobserve(currentTarget);
      }
    };
  }, [observerTarget]);

  return { setObserverTarget };
};

export default useIntersection;
